import Vue from 'vue'
import VueRouter from 'vue-router'

import store from '../store/index'
import cookie from 'vue-cookie'

import Home from '../views/Home/Home.vue'
import Auth from '../views/Auth/Auth.vue'
// import Withdraw from "../views/Withdraw/Withdraw.vue";
import Accounting from '../views/Accounting/Accounting'
import Exchange from '../views/Exchange/Exchange'
import Items from '../views/Items/Items'
import FraudRegistry from '../views/FraudRegistry/FraudRegistry'
import Rns from '../views/Rns/Rns'
import Rights from '../views/Rights/Rights'
import AntiScam from '../views/AntiScam/AntiScam'
import Deposits from '../views/Deposits/Deposits'
import MmTwoBeta from '../views/MmTwoBeta/MmTwoBeta'
import EditPets from '@/views/EditPets/EditPets'
import Balances from '@/views/Balances/Balances'
import BalancesMultiIssue from '@/views/BalancesMultiIssue/BalancesMultiIssue'
import Logs from '@/views/Logs/Logs'
import Reviews from '@/views/Reviews/Reviews'
import SuperPasses from '@/views/Superpasses/Superpasses'
import Descriptions from '@/views/Descriptions/Descriptions'

import GoodsList from '@/views/Goods/List/ListView.vue'
import GoodsCreate from '@/views/Goods/Create/CreateView.vue'
import GoodsEdit from '@/views/Goods/Update/EditView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'Authorization',
    component: Auth,
    meta: { layout: 'Empty' }
  },
  // {
  //   path: "/withdraw",
  //   name: "Withdraw",
  //   component: Withdraw,
  // },
  {
    path: '/exchange',
    name: 'Exchange',
    component: Exchange
  },
  {
    path: '/items',
    name: 'Items',
    component: Items
  },
  {
    path: '/fraud-registry',
    name: 'FraudRegistry',
    component: FraudRegistry
  },
  {
    path: '/rns',
    name: 'Rns',
    component: Rns
  },
  {
    path: '/rights',
    name: 'Rights',
    component: Rights
  },
  {
    path: '/anti-scam',
    name: 'AntiScam',
    component: AntiScam
  },
  {
    path: '/accounting',
    name: 'Accounting',
    component: Accounting
  },
  {
    path: '/deposits',
    name: 'Deposits',
    component: Deposits
  },
  {
    path: '/mm2-beta',
    name: 'Mm2Beta',
    component: MmTwoBeta
  },
  {
    path: '/edit-pets',
    name: 'EditPets',
    component: EditPets
  },
  {
    path: '/descriptions',
    name: 'Descriptions',
    component: Descriptions
  },
  {
    path: '/balances',
    name: 'Balances',
    component: Balances
  },
  {
    path: '/balances-multi',
    name: 'BalancesMultiIssue',
    component: BalancesMultiIssue
  },
  {
    path: '/logs',
    name: 'Logs',
    component: Logs
  },
  {
    path: '/reviews',
    name: 'Reviews',
    component: Reviews
  },
  {
    path: '/superpasses',
    name: 'SuperPasses',
    component: SuperPasses
  },
  {
    path: '/goods',
    name: 'GoodsList',
    component: GoodsList
  },
  {
    path: '/goods/create',
    name: 'GoodsCreate',
    component: GoodsCreate
  },
  {
    path: '/goods/:goodId/edit',
    name: 'GoodsEdit',
    component: GoodsEdit
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    redirect: Home
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const access = cookie.get('token')
  store.state.tokens.access = access
  if (!store.state.permissions && access) await store.dispatch('getAdminStatus')
  if (access) {
    if (to.path === '/') next({ path: '/dashboard' })
    // if ((to.path === "/withdraw" || to.path === "/exchange" || to.path === "/deposits") && !store.state.permissions.admin_payments) next({ path: "/dashboard" });
    if (to.path === '/items' && !store.state.permissions.read_user_items)
      next({ path: '/dashboard' })
    if (to.path === '/deposits' && !store.state.permissions.admin_payments)
      next({ path: '/dashboard' })
    if (to.path === '/fraud-registry' && !store.state.permissions.fraud_support_read)
      next({ path: '/dashboard' })
    if (to.path === '/rns' && !store.state.permissions.rns) next({ path: '/dashboard' })
    if (to.path === '/rights' && !store.state.permissions.super) next({ path: '/dashboard' })
    if (to.path === '/anti-scam' && !store.state.permissions.bot_check) next({ path: '/dashboard' })
    if (to.path === '/accounting' && !store.state.permissions.acc_once_payments)
      next({ path: '/dashboard' })
    if (to.path === '/mm2-beta' && !store.state.permissions.mm_beta_test_admin)
      next({ path: '/dashboard' })
    if (to.path === '/edit-pets' && !store.state.permissions.goods_admin)
      next({ path: '/dashboard' })
    if (to.path === '/descriptions' && !store.state.permissions.goods_admin)
      next({ path: '/dashboard' })
    if (to.path === '/balances' && !store.state.permissions.balances) next({ path: '/dashboard' })
    if (to.path === '/reviews' && !store.state.permissions.manage_reviews)
      next({ path: '/dashboard' })
    if (to.path === '/logs' && !store.state.permissions.super) next({ path: '/dashboard' })
    next()
  } else if (to.path === '/') next()
  else next({ path: '/' })

  next()
})

export default router
